export default {
  add_products: '+ Tilføj produkter',
};
